<!-- -------- desktop header --------- -->
<div class="header d-none d-lg-flex" [ngClass]="{ scrolled: isScrolled }">
  <div class="container d-flex justify-content-between align-items-center w-100">
    <a class="cursor-pointer d-flex flex-column brand" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}"  #navigation (click)="addActive($event, '')">
      <img src="./assets/images/png/logo.png" alt="" class="logo">
    </a>

    <nav class="menu-item d-flex align-items-center">
      @for (item of navigations; track item) {
        @if (item.isPage) {
          <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage + '/' + item.routeName : item.routeName }}"
            (click)="addActive($event, item.routeName)" title="{{ item.routeName }}"
          >{{ item.navName | translate }}</a>
        } @else {
          <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" fragment="{{ item.routeName }}"
            (click)="addActive($event, item.routeName)" title="{{ item.routeName }}"
          >{{ item.navName | translate }}</a>
        }
      }
    </nav>
  </div>
</div>

<!-- -------- mobile header --------- -->
<div class="header d-flex d-lg-none" [ngClass]="{ scrolled: isScrolled }">
  <div class="d-flex justify-content-between align-items-center flex-grow-1 w-100">
    <a class="cursor-pointer d-flex flex-column brand" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}">
      <img src="./assets/images/png/logo.png" alt="" class="logo">
    </a>

    <div class="menu-btn" (click)="openCloseMenu()">
      <svg-icon src="./assets/images/svg-icons/{{ showMenu ? 'close-white' : 'burger-icon' }}.svg"
      [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
    </div>
  </div>

  @if (showMenu) {
    <div class="menu-overlay">
      <div class="sub-menu pull-left" [ngClass]="{ open: openMenu }">
        <div class="d-flex flex-column justify-content-start align-items-start w-100">
          @for (item of navigations; track item) {
            @if (item.isPage) {
              <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage + '/' + item.routeName : item.routeName }}"
                (click)="addActive($event, item.routeName); openCloseMenu()" title="{{ item.routeName }}"
              >{{ item.navName | translate }}</a>
            } @else {
              <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" fragment="{{ item.routeName }}"
                (click)="addActive($event, item.routeName); openCloseMenu()" title="{{ item.routeName }}"
              >{{ item.navName | translate }}</a>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
